import React from 'react';
import { Link } from 'react-router-dom';
//large logo
import Logo from '../components/logo/Logo';
//style
import './nomatch.styl'

class NoMatch extends React.Component {
  render(){
    return(
      <div className='no-match-container'>
        <div className='no-match-inner-container'>
          <h1>Oops, cannot find this page</h1>
          <h1>Back to</h1>
          <div className='no-match-logo-container'>
            <Link to='/'><Logo size='large' ver='unfolded' /></Link>
          </div>
        </div>
      </div>
    );
  }
}

export default NoMatch;



// WEBPACK FOOTER //
// ./src/routes/NoMatch.js